import { Box, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

export const BannerWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2),
}));

export const BannerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  minHeight: 80,
  padding: theme.spacing(2, 3),
  backgroundColor: theme.palette.statePrimaryOverlay.pressed,
  borderRadius: 4,
  boxSizing: 'border-box',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

export const TextContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  flex: 1,
  minWidth: 0,
  paddingRight: theme.spacing(2),
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Lanna',
  fontSize: 18,
  lineHeight: '22px',
  fontWeight: 400,
  color: theme.palette.text.secondary,
}));

export const DescriptionText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Heavent',
  fontSize: 18,
  lineHeight: '22px',
  fontWeight: 500,
  color: theme.palette.text.primary,
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 80,
  height: 80,
  [theme.breakpoints.down('sm')]: {
    width: 56,
    height: 56,
  },
}));

export const RadarIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: alpha(theme.palette.primaryV2.main, 0.12),
  fontSize: 49.6,
  lineHeight: 1,
  [theme.breakpoints.down('sm')]: {
    fontSize: 40,
  },
}));
